import script from "./MediaInput.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaInput.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__